export class AddContentDispatcher {
    static $inject = ['props'];
    constructor(props) {
        Object.assign(this, props);
    }
}
export class Add extends AddContentDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
export class AddWithChatState extends AddContentDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
export class AddWithChatStateUserInput extends AddContentDispatcher {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        Object.assign(this, props);
    }
}
